// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { searchOnlineCoursesActions } from './searchOnlineCoursesActions';
import { searchOnlineCoursesKeywordActions } from './searchOnlineCoursesKeywordActions';
import { searchLabsActions } from './searchLabsActions';
import { searchLabsKeywordActions } from './searchLabsKeywordActions';
import { searchChallengesActions } from './searchChallengesActions';
import { searchChallengesKeywordActions } from './searchChallengesKeywordActions';
import { searchExamsActions } from './searchExamsActions';
import { searchExamsKeywordActions } from './searchExamsKeywordActions';

export default {
  searchOnlineCoursesActions,
  searchOnlineCoursesKeywordActions,
  searchLabsActions,
  searchLabsKeywordActions,
  searchChallengesActions,
  searchChallengesKeywordActions,
  searchExamsActions,
  searchExamsKeywordActions
}
